// extracted by css-extract-rspack-plugin
export default {"root":"SortableHeader-module__root___wGcAK","headerContent":"SortableHeader-module__headerContent___pwUQ7","resizeHandle":"SortableHeader-module__resizeHandle___mnyW9"};